import {
  Avatar,
  Card,
  CardActionArea,
  CircularProgress,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import BlockIcon from '@mui/icons-material/Block';
import { CSSProperties, FC } from "react";

interface VirtualBatteryPercentageCardParams {
  percentageData: {
    percentage: number;
    polissaName: string;
  }
  active: boolean,
  style?: CSSProperties;
  locked: boolean;
  lockedMessage: string;
}

/**
 * UI component
 *
 * Responsible for rendering the provided percentage data.
 */
const VirtualBatteryPercentageCard: FC<VirtualBatteryPercentageCardParams> = ({
  percentageData,
  active,
  style = {},
  locked,
  lockedMessage,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const listItemRender = (
    <>
      <ListItem
        style={{ width: "50%", ...style }}
        selected={active}
        disabled={!!locked}
      >
        <ListItemAvatar>
          <Avatar>
            <CircularProgress
              style={{
                backgroundColor:
                  theme.palette.grey[
                  theme.palette.mode === "light" ? 200 : 700
                  ],
              }}
              variant="determinate"
              value={percentageData.percentage}
            />
            {locked && (
              <BlockIcon style={{ fill: "red", position: "absolute" }} />
            )}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={`${t("common:text.solar_wallet.move.contract")}: ${percentageData.polissaName
            }`}
          secondary={`${percentageData.percentage.toFixed(2)}%`}
        />
      </ListItem>
    </>
  );

  if (percentageData) {
    if (locked) {
      return (
        <Tooltip title={lockedMessage}>
          <Card elevation={0}>
            <CardActionArea disableRipple>
              {listItemRender}
            </CardActionArea>
          </Card>
        </Tooltip>
      )
    } else {
      return listItemRender;
    }
  }
};

export default VirtualBatteryPercentageCard;
